import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { IPaginationUsersImpact, IUsersImpact } from '../../students-for-impact/students-for-impact-list/ipagination-impact.model';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';

export class CitizensForImpactListDataSource implements DataSource<IUsersImpact> {

  private usersSubject = new BehaviorSubject<IUsersImpact[]>([]);
  private paginationSubject = new BehaviorSubject<IPaginationUsersImpact>({} as IPaginationUsersImpact);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: StudentsForImpactService) { }

  connect(_collectionViewer: CollectionViewer): Observable<IUsersImpact[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.usersSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(search = '', offset = 1, limit = 50, sort = null) {
    this.loadingSubject.next(true);

    this.service.findImpact({ offset, limit, search, impact_type_ids: '2,3' } as DataTableParams, true).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPaginationUsersImpact) => {
      if (data && data.data) {
        this.usersSubject.next(data.data);
      } else {
        this.usersSubject.next([]);
      }

      if (sort) {
        let list = data.data;
        list = list.sort((item1, item2) => {
          const sortAsc = sort['sortAsc'];
          const fieldToSort = sort['sortBy'];
          let firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
          let secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

          firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '') : firstVal : '';
          secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '') : secondVal : '';

          return sortAsc ?
            firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0 :
            firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
        });
        data.data = list;
      }

      this.paginationSubject.next(data);
    });
  }
}
